import React, { createContext, useContext } from "react";

const FinanceScopeContext = createContext(null);

export function FinanceScopeProvider({ children }) {
    return <FinanceScopeContext.Provider value={{ inFinance: true }}>{children}</FinanceScopeContext.Provider>;
}

export function useFinanceScope() {
    return useContext(FinanceScopeContext);
}
